import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { authService } from '../api/axios'; // Adjust path if necessary
import { Box, Typography, CircularProgress, Alert, Link } from '@mui/material';

function EmailVerificationStatus() {
  const [status, setStatus] = useState('Verifying your email...');
  const [error, setError] = useState('');
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
      const verifyEmail = async () => {
        try {
          console.log('Attempting email verification API call...');
          const response = await authService.get(`/auth/verify-email?token=${token}`);
          setStatus(response.data); // Set success message from backend
          setError('');
          console.log('Email verification successful:', response.data);
        } catch (err) {
          console.error('Email verification failed:', err.response || err);
          setError(err.response?.data || 'Email verification failed. Invalid or expired token.');
          setStatus('');
        }
      };
      verifyEmail();
    } else {
      setError('Verification token is missing.');
      setStatus('');
    }
  }, [location.search]);

  return (
    <Box sx={{ p: 3, textAlign: 'center' }}>
      {status && <Typography variant="h5" sx={{ color: 'success.main' }}>{status}</Typography>}
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
      {!status && !error && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="h6">Verifying your email...</Typography>
        </Box>
      )}
      <Typography variant="body1" sx={{ mt: 3 }}>You can now go to the <Link href="/login">login page</Link>.</Typography>
    </Box>
  );
}

export default EmailVerificationStatus;